import React, { useState } from "react";
import { Button } from "./ui/button";
import { Search, Loader2, Sparkles } from "lucide-react";

export const PlateInput = ({ onSubmit, loading }) => {
  const [plate, setPlate] = useState("");

  // Formatage automatique AA-123-AA
  const formatPlate = (v) => {
    const clean = v.toUpperCase().replace(/[^A-Z0-9]/g, "");
    if (clean.length <= 2) return clean;
    if (clean.length <= 5) return `${clean.slice(0, 2)}-${clean.slice(2)}`;
    return `${clean.slice(0, 2)}-${clean.slice(2, 5)}-${clean.slice(5, 7)}`;
  };

  const handleChange = (e) => setPlate(formatPlate(e.target.value));
  const handleSubmit = (e) => {
    e.preventDefault();
    if (plate.trim()) onSubmit(plate.trim());
  };

  return (
    <form
      data-testid="plate-form"
      onSubmit={handleSubmit}
      className="w-full max-w-2xl"
    >
      <div className="relative flex overflow-hidden rounded-2xl bg-slate-100 shadow-2xl shadow-cyan-500/10 ring-1 ring-slate-900/10">
        <div className="plate-strip w-12 shrink-0 py-3 text-center sm:w-14">
          <span className="text-2xl sm:text-3xl">★</span>
          <span className="text-xs sm:text-sm">F</span>
        </div>

        <input
          data-testid="license-plate-input"
          type="text"
          value={plate}
          onChange={handleChange}
          placeholder="AA-123-AA"
          maxLength={9}
          autoComplete="off"
          className="plate-input flex-1 border-0 bg-transparent px-4 py-5 text-center text-2xl sm:text-4xl focus:ring-0"
          aria-label="Plaque d'immatriculation française"
        />

        <div className="plate-strip w-12 shrink-0 py-3 text-center sm:w-14">
          <span className="text-sm font-bold">FR</span>
          <span className="text-[10px]">UE</span>
        </div>
      </div>

      <div className="mt-5 flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
        <Button
          data-testid="plate-search-submit"
          type="submit"
          disabled={loading || !plate.trim()}
          size="lg"
          className="btn-primary-glow gap-2 bg-cyan-500 px-8 text-base font-semibold text-slate-950 shadow-[0_8px_30px_rgba(6,182,212,0.4)] hover:bg-cyan-400"
        >
          {loading ? (
            <>
              <Loader2 className="h-5 w-5 animate-spin" />
              Identification...
            </>
          ) : (
            <>
              <Search className="h-5 w-5" />
              Identifier mon véhicule
            </>
          )}
        </Button>
        <div className="flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-slate-500">
          <Sparkles className="h-3.5 w-3.5 text-amber-400" />
          Analyse IA en 1,2s
        </div>
      </div>
    </form>
  );
};
